import DeleteModal from './ModalAlert';
export default DeleteModal;
